import { render, staticRenderFns } from "./newheader.vue?vue&type=template&id=820e7b68&scoped=true"
import script from "./newheader.vue?vue&type=script&lang=js"
export * from "./newheader.vue?vue&type=script&lang=js"
import style0 from "./newheader.vue?vue&type=style&index=0&id=820e7b68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820e7b68",
  null
  
)

export default component.exports